import React from 'react'

export default function AddInfo({addInfo,removeAddInfo,id}) {
	return (
		<>
			<li className="details-list-item"><h3><strong>{addInfo.title}</strong></h3>
				{removeAddInfo && (<span className="close-icon"><button onClick={()=>removeAddInfo(id)}><i class="far fa-trash-alt"></i></button></span>)}
				<div>
					<span className="link-style">{addInfo.reference}</span>
				</div>
			</li>
		</>
	)
}